module.exports = __webpack_public_path__ + "static/media/GO_C_enriched_terms.4db4aeba.zip";